import React, { Component } from 'react';
import { connect } from 'react-redux';
import ChannelDetailsView from './ChannelDetails.view';

import enums from '../../../../constants/enums';

export class ChannelDetailsContainer extends Component {

  constructor(props){
    super(props);
    this.state = {
      channelTypes: enums.salesChannelTypes,
      channelStatus: enums.salesChannelStatus,
    };

    this.submitForm = this.submitForm.bind(this);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
  }

  toggleEdit(){
    const { channel, dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_CHANNEL_EDIT',
    });
    this.setState({
      formState: {
        data: channel,
      }
    });
  }

  onFormUpdate(formState, action) {
    this.setState({
      formState
    });
  }

  submitForm(formState) {
    const { dispatch, channel, context, filtersFormState, page } = this.props;
    const { orderNumber, completed, status } = this.state.formState.data;
    dispatch({
      $global: true,
      type: 'UPDATE_CHANNEL_DETAILS',
      payload: {
        context,
        page,
        filters: filtersFormState && filtersFormState.data,
        _id: channel._id,
        data: {
          orderNumber,
          completed,
          status,
        }
      }
    });
  }

  render() {
    return (<ChannelDetailsView
      {...this.props}
      {...this.state}
      submitForm={this.submitForm}
      onFormUpdate={this.onFormUpdate}
      toggleEdit={this.toggleEdit}
    />);
  }

}

function mapStateToProps(state, ownProps) {

  return {
    editing: state.channelDetails.editing,
    channel: ownProps.channel,
  };
}

export default connect(mapStateToProps)(ChannelDetailsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/ChannelDetails/ChannelDetails.container.js